import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSessionUser as GetSessionUserQuery,
    GetSessionUser_loggedInUser,
} from 'nutshell-graphql-types';

import GET_SESSION_USER from './graphql/queries/get-session-user.graphql';

type Return = {
    isLoading: boolean;
    user: GetSessionUser_loggedInUser | null | undefined;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
    startPolling: (arg1: number) => void;
    stopPolling: () => void;
};

export const useGetSessionUser = (): Return => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
        startPolling,
        stopPolling,
    } = useQuery<GetSessionUserQuery, Record<any, any>>(GET_SESSION_USER, {
        fetchPolicy: 'cache-and-network',
    });

    const loggedInUser = data ? data.loggedInUser : null;

    return {
        isLoading,
        user: loggedInUser,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
        startPolling,
        stopPolling,
    };
};
